module.exports = __webpack_public_path__ + "assets/img/workDrive.eee7a0a2.svg";